import React from 'react'
import cx from 'classnames'

import Card from './Card'
import logo from '../../images/WiC_Logo_white.png'
import style from '../../scss/ui/instructions.scss'

const InstructionsCard = () => (
    <Card title="">
        <div className={cx(style.instructions)}>
            <h2>Adjust the sliders toward the qualities you most value in your small council.</h2>
            <img src={logo} alt="Winter is Coming logo" className={style.instructions} />
        </div>
    </Card>
)

export default InstructionsCard



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/InstructionsCard.js